import React from 'react';

const DEFAULT_MAX_CHARS_CONSTRAINT = 20;
const DEFAULT_TRUNCATE_SUFFIX = '...';

const TruncateText = ({children, maxChars = DEFAULT_MAX_CHARS_CONSTRAINT, truncateSuffix = DEFAULT_TRUNCATE_SUFFIX,}) =>
  children
  ? <>{maxChars < 1 ? children : children.length > maxChars ? `${children.slice(0, maxChars).trim()}${truncateSuffix}` : children.trim()}</>
  : <></>
  ;

export default TruncateText;